import { useEffect, useRef } from 'react'
import replaceBrowserHistory from '@pancakeswap/utils/replaceBrowserHistory'
import { useAppDispatch } from '../state'
import { clearUserStates } from '../utils/clearUserStates'
import useActiveWeb3React from './useActiveWeb3React'
import { useSessionChainId } from './useSessionChainId'

export const useAccountEventListener = () => {
  const { account, chainId, connector } = useActiveWeb3React()
  const [, setSessionChainId] = useSessionChainId()
  const dispatch = useAppDispatch()
  const accountRef = useRef(account)
  const chainIdRef = useRef(chainId)

  useEffect(() => {
    if (account !== accountRef.current || chainId !== chainIdRef.current) {
      accountRef.current = account
      chainIdRef.current = chainId
    }
  }, [account, chainId])

  useEffect(() => {
    if (!account || !connector) return undefined

    const handleAccountsChanged = (accounts: string[]) => {
      if (accounts.length === 0) {
        clearUserStates(dispatch, { chainId: chainIdRef.current })
      }
    }

    const handleChainChanged = (newChainId: number | string) => {
      const id = Number(newChainId)
      replaceBrowserHistory('chainId', id)
      setSessionChainId(id)
      clearUserStates(dispatch, { chainId: chainIdRef.current, newChainId: id })
    }

    const handleDisconnect = () => {
      clearUserStates(dispatch, { chainId: chainIdRef.current })
    }

    connector.emitter?.on('change', ({ accounts, chainId: newChainId }: any) => {
      if (accounts) handleAccountsChanged(accounts)
      if (newChainId) handleChainChanged(newChainId)
    })
    connector.emitter?.on('disconnect', handleDisconnect)

    return () => {
      connector.emitter?.off('change', handleDisconnect)
      connector.emitter?.off('disconnect', handleDisconnect)
    }
  }, [account, dispatch, connector, setSessionChainId])
}
